export const storeWindowSize = (width, height) => ({
  type: 'STORE_WINDOW_SIZE',
  width,
  height
})

export const setScriptsLoaded = (scriptsLoaded) => ({
  type: 'SET_SCRIPTS_LOADED',
  scriptsLoaded
})
